export default {
  plans: [
    {
      name: 'Small Enterprise',
      price: 'Please Contact Us',
      count: '1 - 2',
      services: [
        'Product Traceability Platform',
        'Traceability Management System',
        'Decentralized Database Based on Blockchain'
      ]
    },
    {
      name: 'Large Enterprise',
      price: 'Please Contact Us',
      count: '3 - 5',
      services: [
        'Product Traceability Platform',
        'Traceability Management System',
        'Decentralized Database Based on Blockchain'
      ]
    }
  ],
  IoTs: [
    {
      name: 'Field Sensor',
      cover: require('@/assets/IOT02.jpg'),
      description: `Leasing contract for at least 1 year with 1 year free warranty.\n Once the equipment is leased for over 2 years, it will be given to you.`
    },
    {
      name: 'Gateway',
      cover: require('@/assets/IOT03.jpg'),
      description: `Leasing contract for at least 1 year with 1 year free warranty.\n Once the equipment is leased for over 2 years, it will be given to you.`
    }
  ]
}
